import React, { useEffect, useContext } from 'react';
import { AppSettings } from '../../config/app-settings.js';
import { Oval } from 'react-loader-spinner';
import Swal from 'sweetalert2';
import ModellingMap from '../../components/map/modelling-map.jsx';
import useModelMappingStore from '../../stores/model-mapping-store.js';
import { useAvailableLayers } from '../../hooks/useModelMapping.js';

function ModelMapping() {
  const context = useContext(AppSettings);

  // React Query - fetch layers (service does processing)
  const { isLoading, isError, error, isFetching } = useAvailableLayers();

  // Setup app layout (match evacuation-portal pattern)
  useEffect(() => {
    context.handleSetAppContentClass('p-0');
    context.handleSetAppSidebarTwo(true);
    context.handleSetAppSidebarWide(true);
    context.handleSetAppTopMenu(true);
    context.setAppSidebarEndToggled(false);

    return () => {
      console.log('🧹 Model Mapping unmounting - clearing store state');
      // Clear store state on page unmount
      useModelMappingStore.getState().clearAll();

      context.handleSetAppSidebarTwo(false);
      context.handleSetAppSidebarWide(false);
      context.handleSetAppTopMenu(false);
      context.setAppSidebarEndToggled(false);
    };
  }, []); // intentionally mirror evacuation-portal pattern

  // Show Swal warning when no GeoJSON layers are available (API returns 404)
  useEffect(() => {
    if (!isLoading && isError) {
      Swal.fire({
        icon: 'warning',
        title: 'No Layers Available',
        text: 'There are no GeoJSON layers configured for this client. Please contact your administrator to set up model mapping layers.',
        confirmButtonText: 'OK',
      });
    }
  }, [isLoading, isError]);

  // Loading state
  if (isLoading || isFetching) {
    return (
      <div className="loading-overlay">
        <div className="loading-content">
          <Oval
            height={80}
            width={80}
            color="var(--bs-app-theme)"
            wrapperStyle={{}}
            wrapperClass="justify-content-center"
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="var(--bs-app-theme)"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
          <h5 className="mt-3 text-white">Loading Map Layers</h5>
          <p className="text-gray-300">
            Processing GeoJSON data...
          </p>
        </div>
      </div>
    );
  }

  // Error state
  if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="alert alert-warning m-4">
          <h4 className="alert-heading">
            <i className="fa fa-info-circle me-2"></i>
            No Layers Available
          </h4>
          <p className="mb-0">
            There are no GeoJSON layers configured for this client.
          </p>
          <hr />
          <p className="mb-0">
            <small>Please contact your administrator to set up model mapping layers for your organization.</small>
          </p>
        </div>
      </div>
    );
  }

  // Map reads layers/visibility/selection from hooks + Zustand internally — no props required
  return (
    <div className="row gx-0">
      <div className="col-sm-12 p-0">
        <div className="card border-0 overflow-hidden bg-gray-800 text-white">
          <div className="card-body p-0">
            <ModellingMap
              center={[48.4801, -123.4085]}
              zoom={9}
              height={`calc(100vh - var(--app-header-height, 60px) - var(--app-top-menu-height, 40px))`}
              width="100%"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModelMapping;